import React, { useEffect, useState, useRef } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Col,
  Row,
  Card,
  CardText,
  Form,
  CardBody,
} from "reactstrap";
import Dropzone from "react-dropzone";
import SweetAlert from "react-bootstrap-sweetalert";
import readXlsxFile from "read-excel-file";

import ModeloUpload from "../../../../../assets/statics/modelo_importacao_cp.xlsx";
import { formatBytes } from "../../../../../utils/helpers/files/formatBytes";

import ModalExcelRows from "../modals/ModelExcelRows";
import { createCps } from "../../../../../utils/services/portalBoticario";

export const ModalImportCP = (props) => {
  const { isOpen, toggle, eventId, jwt, refetch } = props;

  const [selectedFiles, setselectedFiles] = useState([]);
  const [successDlg, setSuccessDlg] = useState(false);

  const [totalRows, setTotalRows] = useState(0);
  const [totalSended, setTotalSended] = useState(0);

  const [btnSend, setBtnSend] = useState(false);
  const [btnCancel, setBtnCancel] = useState(false);

  const importActivated = useRef(false);

  const [modalErrors, setModalErrors] = useState(false);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    setselectedFiles([]);
  }, [isOpen]);

  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }),
    );

    setselectedFiles(files);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(true);
  }

  function cancelImport() {
    importActivated.current = false;
    setselectedFiles([]);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(false);
    setBtnCancel(false);
  }

  async function uploadService() {
    setErrors([]);

    try {
      importActivated.current = true;
      setBtnSend(false);
      setBtnCancel(true);

      const schema = {
        Nome: { prop: "name", type: String },
        Codigo: { prop: "code", type: String },
        Quantidade: { prop: "count", type: Number },
      };

      let successCount = 0;
      const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

      if (!selectedFiles.length || !selectedFiles[0]) {
        setErrors(["Nenhum arquivo selecionado"]);
        setModalErrors(true);
        return;
      }

      const { rows } = await readXlsxFile(selectedFiles[0], { schema });

      if (!rows || rows.length === 0) {
        setErrors([]);
        setModalErrors(true);
        return;
      }

      const validatedRows = rows.map((row, index) => {
        const errors = [];

        if (!row.name) errors.push("Nome");
        if (!row.code) errors.push("Código");

        if (
          row.count === undefined ||
          row.count === null ||
          isNaN(Number(row.count)) ||
          Number(row.count) <= 0
        ) {
          errors.push("Quantidade");
        }

        return {
          ...row,
          rowIndex: index + 1,
          errors,
        };
      });

      const rowsWithError = validatedRows.filter(
        (row) => row.errors.length > 0,
      );

      setTotalRows(validatedRows.length);

      if (rowsWithError.length > 0) {
        const formattedErrors = rowsWithError.map((row) => ({
          row: row.rowIndex,
          fields: row.errors,
        }));

        setErrors(formattedErrors);
        setModalErrors(true);
        return;
      }

      for (let i = 0; i < validatedRows.length; i++) {
        if (!importActivated.current) break;

        const row = validatedRows[i];

        try {
          const cpData = {
            name: row.name,
            code: row.code.trim().toUpperCase().replace(/\s+/g, ""),
            count: Number(row.count),
            eventId,
          };

          await createCps(cpData, jwt);

          successCount++;
          setTotalSended((prev) => prev + 1);
        } catch (error) {
          console.error("Erro ao importar CP:", error);

          let message = `Linha ${row.rowIndex}: erro ao importar`;

          if (error?.response?.data?.message === "CODE ALREADY EXISTS") {
            message = `Linha ${row.rowIndex}: Código já existe`;
          }

          setErrors((prev) => [
            ...prev,
            {
              row: row.rowIndex,
              message,
            },
          ]);
          setModalErrors(true);
        }

        await sleep(100);
      }

      if (successCount > 0) {
        setSuccessDlg(true);
        setBtnCancel(false);
        refetch();
      }
    } catch (error) {
      console.error("Erro geral:", error);
      setErrors(["Erro no processo de importação"]);
      setModalErrors(true);
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      {successDlg && (
        <SweetAlert
          success
          title="Importação"
          onConfirm={() => {
            toggle();
            setSuccessDlg(false);
          }}
        >
          CPs importados com sucesso!
        </SweetAlert>
      )}

      {modalErrors && (
        <ModalExcelRows toggle={() => setModalErrors(false)} rows={errors} />
      )}

      <ModalHeader toggle={toggle}>Importar CPs</ModalHeader>

      <ModalBody className="p-0">
        <Card className="p-1">
          <CardBody className="p-2">
            <CardText>
              O arquivo a ser importado deve seguir este{" "}
              <a href={ModeloUpload} download="modelo_importacao_cp.xlsx">
                Modelo
              </a>
              , não modifique seu cabeçalho.
            </CardText>

            <Form>
              {selectedFiles.length === 0 && (
                <Dropzone onDrop={handleAcceptedFiles}>
                  {({ getRootProps, getInputProps }) => (
                    <div
                      className="dropzone"
                      {...getRootProps()}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: 180,
                        border: "2px dashed #ccc",
                        borderRadius: 8,
                        cursor: "pointer",
                      }}
                    >
                      <input {...getInputProps()} />

                      <div className="text-center">
                        <i className="bx bxs-cloud-upload display-4" />
                        <h4>Arraste ou clique para selecionar</h4>
                      </div>
                    </div>
                  )}
                </Dropzone>
              )}

              {selectedFiles.map((f, i) => (
                <Card key={i} className="mt-3">
                  <Row className="p-3 align-items-center">
                    <Col xs="10">
                      <strong>
                        {f.name} - {f.formattedSize}
                      </strong>
                    </Col>

                    <Col xs="2" className="text-end">
                      <span
                        className="mdi mdi-close"
                        style={{
                          color: "red",
                          cursor: "pointer",
                          fontSize: 18,
                        }}
                        onClick={() => setselectedFiles([])}
                      />
                    </Col>

                    {importActivated.current && (
                      <Col xs="12" className="mt-2 text-center">
                        <strong>
                          Enviado: {totalSended}/{totalRows}
                        </strong>
                      </Col>
                    )}
                  </Row>
                </Card>
              ))}
            </Form>

            <div className="text-center mt-3">
              <button
                disabled={!btnSend}
                className="btn btn-primary"
                onClick={uploadService}
              >
                Enviar CPs
              </button>

              <button
                className="btn btn-danger mx-2"
                disabled={!btnCancel}
                onClick={cancelImport}
              >
                Cancelar
              </button>
            </div>
          </CardBody>
        </Card>
      </ModalBody>
    </Modal>
  );
};
